export const getShareUrlEllipsis = (link: string, maxLength = 32) => {
  if (!link) return '';
  const shortName = link.split('/').slice(-1)[0];

  const url_ = link.split('/').slice(0, -1).join('/');
  const ellipsis = '.../';
  const urlLength = url_.length;
  const shortNameLength = shortName.length;
  const totalLength = urlLength + shortNameLength;
  if (totalLength <= maxLength) {
    return url_ + '/' + shortName;
  }
  const maxUrlLength = maxLength - shortNameLength;
  const maxUrlLength_ = maxUrlLength < 0 ? 0 : maxUrlLength;
  return url_?.slice(0, maxUrlLength_) + ellipsis + shortName;
};
